export default __webpack_public_path__ + "6ef232e250f2c284370fac5870b79fb5.png";